<script setup lang="ts">
import ExpansionPanel from "@/shared/components/expansion/expansion-panel.vue";
import QitBtn from "@/shared/components/buttons/qit-button.vue";
import { computed, toRefs } from "vue";
import { WidgetContext } from "@/shared/environment/widgets/widget-context.ts";
import WidgetCard from "@/shared/components/widgets/widget-card.vue";
import ShowIfHasAccess from "@/shared/access-control/components/show-if-has-access.vue";
import { AccessFeature } from "@/shared/access-control/access-control.ts";

const props = defineProps<{
    widgetContext: WidgetContext;
}>();

const { widgetContext } = toRefs(props);

const articleId = computed(() => {
    if (widgetContext.value.__type === "mechanicArticle") {
        return widgetContext.value.articleId;
    }
    return undefined;
});

const url = computed(() => {
    return `https://app.partium.io/catalog/parts/${articleId.value}`;
});
</script>

<template>
    <ShowIfHasAccess :feature-id="AccessFeature.connect26_gui">
        <ExpansionPanel :label="$t('shared.Apps')" icon="fa-regular fa-gear">
            <div class="row" :class="$q.screen.xs ? 'q-col-gutter-sm' : 'q-col-gutter-lg'">
                <div class="col-12 col-md-6">
                    <WidgetCard
                        icon="fa-light fa-brain-circuit icon-light-color"
                        :title="$t('mechanic.Open partium Parts Intelligence')"
                        :description="
                            $t('mechanic.Open the installation location in the partium Parts Intelligence platform')
                        "
                    >
                        <template #button>
                            <div class="flex justify-end">
                                <a :href="url" target="_blank" rel="noopener noreferrer">
                                    <QitBtn
                                        color="secondary"
                                        data-qs="identify-part-item-button"
                                        :label="$t('mechanic.Open partium')"
                                    />
                                </a>
                            </div>
                        </template>
                    </WidgetCard>
                </div>
            </div>
        </ExpansionPanel>
    </ShowIfHasAccess>
</template>
